---
title: "Launch Booked for Q4 2027"
date: 2025-11-13
category: "News"
---

We've booked a launch for Q4 2027. Having a confirmed slot on the manifest changes everything.

## A Real Date

There's something different about working toward a real date versus a notional schedule. Decisions get sharper. Priorities get clearer. The team is energized in a way that's hard to replicate with placeholder milestones.

Having a launch booked means our timeline is no longer theoretical. Every milestone now counts backward from a fixed point. The engineering work we've been doing—the [mass simulator MRR](/blog/dynamic-test-model-manufacturing-readiness-review-complete), the [Zerodur blanks](/blog/zerodur-mirror-blanks-complete)—all of it feeds into a real mission with a real launch date.

## What's Next

We'll share more details as we're able. For now, we're heads down executing against the schedule. Q4 2027 will be here before we know it.
